import {createSelector} from 'reselect';
import {getTranslations} from './store';
import {getHostType} from './listing';

const getContactButtonLabel = createSelector(
    [getHostType, getTranslations],
    (hostType, translations) => {
        const label = hostType.owner ? translations.contactOwner : translations.contactManager;

        return label || '';
    }
);

const getListingLabels = createSelector(
    [getContactButtonLabel],
    (contactButton) => {
        return {
            contactButton
        };
    }
);

export default getListingLabels;

export {getListingLabels, getContactButtonLabel};
